module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-swipe"
  }, [_c('swipe', {
    attrs: {
      "speed": _vm.speed,
      "auto": _vm.auto,
      "continuous": _vm.continuous,
      "showIndicators": _vm.showIndicators,
      "prevent": _vm.prevent
    }
  }, _vm._l((_vm.images), function(item, index) {
    return _c('swipe-item', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.handleClick(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e7f082","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-swipe/index.vue
// module id = 1049
// module chunks = 2